import React, { useEffect, useState } from 'react';
import './Toast.css';

// Simple singleton-ish API: `showToast(message, timeout = 3000)`
let _show = null;
export function showToast(message, timeout = 3000) {
  if (_show) _show(message, timeout);
}

export default function ToastContainer() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    _show = (message, timeout = 3000) => {
      setToast({ message });
      window.clearTimeout(ToastContainer._timer);
      ToastContainer._timer = window.setTimeout(() => setToast(null), timeout);
    };
    return () => {
      _show = null;
      window.clearTimeout(ToastContainer._timer);
    };
  }, []);

  if (!toast) return null;

  return (
    <div className="toast-container" role="status" aria-live="polite">
      <div className="toast">{toast.message}</div>
    </div>
  );
}
